export interface VivenciaQuestion {
  id: string
  label: string
  placeholder: string
}

export interface Vivencia {
  /** chave curta usada em classes/estilos */
  key: 'terra' | 'agua' | 'fogo' | 'ar' | 'cocriacao'
  number: number
  title: string
  glyph: string
  accent: string
  accentSoft: string
  ambient: string
  intro: string
  questions: VivenciaQuestion[]
}

export const VIVENCIAS: Vivencia[] = [
  {
    key: 'terra',
    number: 1,
    title: 'Vivência 1 — Terra',
    glyph: '🌱',
    accent: '#6B8E4E',
    accentSoft: '#8FAE6F',
    ambient: 'bg-ambient-terra',
    intro:
      'Terra é a sua base. É tudo que diz respeito ao corpo, ao material, ao dinheiro, à segurança e à estabilidade. Sem uma base sólida, nenhum outro elemento consegue florescer. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    questions: [
      {
        id: 'terra1',
        label:
          'O que você quer TER na sua vida? Descreva com detalhes, no financeiro, no corpo, na saúde, na estabilidade e em tudo que representa segurança e conquista para você.',
        placeholder: 'Escreva sem filtro, do jeito que vier...',
      },
      {
        id: 'terra2',
        label:
          'O que te impede de decidir mudar sua vida agora? O que, ou quem, te prende no mesmo lugar?',
        placeholder: 'O que aparece quando você pensa em mudar...',
      },
      {
        id: 'terra3',
        label:
          'Você sente que não merece ter prosperidade, abundância e estabilidade? De onde veio essa crença?',
        placeholder: 'De onde isso vem, na sua história...',
      },
      {
        id: 'terra4',
        label:
          'Quem na sua vida, pai, mãe, parceiro ou familiar, te passou a ideia de que dinheiro é difícil, escasso ou perigoso?',
        placeholder: 'Quem falava isso, e como falava...',
      },
      {
        id: 'terra5',
        label: 'Você tem vergonha de algo do seu passado que ainda carrega hoje? O que é?',
        placeholder: 'O que você nunca contou para ninguém...',
      },
      {
        id: 'terra6',
        label:
          'O que você evita decidir ou assumir na sua vida por medo de errar ou decepcionar alguém?',
        placeholder: 'O que está esperando uma decisão sua...',
      },
    ],
  },
  {
    key: 'agua',
    number: 2,
    title: 'Vivência 2 — Água',
    glyph: '💧',
    accent: '#3B7BB8',
    accentSoft: '#5FA0D9',
    ambient: 'bg-ambient-agua',
    intro:
      'Água é tudo que diz respeito às suas emoções, aos seus relacionamentos, ao merecimento e ao prazer de viver. Quando a Água está bloqueada, a vida perde sabor e as relações perdem profundidade. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    questions: [
      {
        id: 'agua1',
        label:
          'Como você quer se SENTIR na sua vida? Descreva como quer estar emocionalmente, como quer se relacionar, o que quer sentir no amor, nas amizades e em você mesma.',
        placeholder: 'Como você quer se sentir por dentro...',
      },
      {
        id: 'agua2',
        label:
          'Quem você realmente não quer mais na sua vida, mas ainda mantém por obrigação, culpa ou medo?',
        placeholder: 'Quem, e o que te prende ainda...',
      },
      {
        id: 'agua3',
        label: 'Você acredita que merece receber amor, cuidado e coisas boas? Se não, por quê?',
        placeholder: 'O que você acredita sobre merecer...',
      },
      {
        id: 'agua4',
        label:
          'Existe alguém com quem você se compara e sente que não é suficiente? Quem é e por quê?',
        placeholder: 'Quem é essa pessoa, e o que ela tem...',
      },
      {
        id: 'agua5',
        label:
          'Quem te ensinou que demonstrar sentimentos é fraqueza ou que suas emoções não importam?',
        placeholder: 'Onde você aprendeu a se calar...',
      },
      {
        id: 'agua6',
        label:
          'Existe algum relacionamento, afetivo, familiar ou de amizade, que drena sua energia e mesmo assim você mantém? O que te prende nele?',
        placeholder: 'O que te faz ficar, mesmo doendo...',
      },
    ],
  },
  {
    key: 'fogo',
    number: 3,
    title: 'Vivência 3 — Fogo',
    glyph: '🔥',
    accent: '#E07B3C',
    accentSoft: '#F09A5E',
    ambient: 'bg-ambient-fogo',
    intro:
      'Fogo é tudo que diz respeito à sua ação, ao seu trabalho, ao seu propósito e ao seu poder pessoal. Quando o Fogo está bloqueado, você começa e não termina, procrastina e sente que nunca chega lá. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    questions: [
      {
        id: 'fogo1',
        label:
          'O que você vai FAZER para criar a vida que deseja? Descreva seus projetos, seu trabalho, seu propósito e as ações que quer tomar.',
        placeholder: 'O que você quer colocar em movimento...',
      },
      {
        id: 'fogo2',
        label: 'O que você fica adiando que sabe que precisa fazer? Por que não faz?',
        placeholder: 'O que está sempre para depois...',
      },
      {
        id: 'fogo3',
        label: 'Você sente que não é boa o suficiente para ter sucesso? De onde veio essa crença?',
        placeholder: 'De onde vem essa voz que duvida...',
      },
      {
        id: 'fogo4',
        label:
          'Existe alguém cuja opinião ou julgamento te paralisa e te impede de agir? Quem é?',
        placeholder: 'De quem é o julgamento que te trava...',
      },
      {
        id: 'fogo5',
        label:
          'Quais padrões de autossabotagem você percebe se repetindo na sua vida, no trabalho, nos projetos e nas finanças?',
        placeholder: 'O que sempre acontece de novo...',
      },
      {
        id: 'fogo6',
        label: 'O que te faz desanimar e querer parar quando está quase chegando lá?',
        placeholder: 'O que acontece quando você está quase...',
      },
    ],
  },
  {
    key: 'ar',
    number: 4,
    title: 'Vivência 4 — Ar',
    glyph: '🌬️',
    accent: '#B9A3D9',
    accentSoft: '#D4C3EA',
    ambient: 'bg-ambient-ar',
    intro:
      'Ar é tudo que diz respeito ao amor, ao perdão, à paz e ao equilíbrio. É o elemento mais elevado e só se abre quando os outros três começam a se mover. Quando o Ar está bloqueado, há raiva, mágoa, dificuldade de perdoar e de receber. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    questions: [
      {
        id: 'ar1',
        label:
          'Como você vai AMAR e se relacionar quando tiver a vida que deseja? Descreva como quer amar, ser amada, viver em paz e se conectar com o Divino.',
        placeholder: 'Como você quer amar e ser amada...',
      },
      {
        id: 'ar2',
        label:
          'Existe alguém que você ainda não perdoou e que carrega como um peso? Quem é e o que aconteceu?',
        placeholder: 'Quem ainda está no seu peito...',
      },
      {
        id: 'ar3',
        label:
          'Você consegue pedir ajuda quando precisa ou prefere resolver tudo sozinha? O que te impede de receber?',
        placeholder: 'O que te impede de receber...',
      },
      {
        id: 'ar4',
        label:
          'Como é a sua relação com seu pai e sua mãe, ou com as figuras que representam o masculino e o feminino na sua vida? Existe mágoa, distância ou algo não resolvido?',
        placeholder: 'O que ficou sem ser dito...',
      },
      {
        id: 'ar5',
        label:
          'Existe raiva, ressentimento ou mágoa que você carrega em relação a alguém e que ainda não conseguiu soltar? Quem é essa pessoa?',
        placeholder: 'O que ainda pesa, e em quem...',
      },
      {
        id: 'ar6',
        label: 'O que, ou quem, te impede de viver em paz e em equilíbrio hoje?',
        placeholder: 'O que tira a sua paz...',
      },
    ],
  },
  {
    key: 'cocriacao',
    number: 5,
    title: 'Vivência 5 — Cocriação',
    glyph: '✨',
    accent: '#C8923A',
    accentSoft: '#E0B870',
    ambient: 'bg-ambient',
    intro:
      'Você chegou até aqui. As quatro vivências revelaram seus padrões, suas dores e sua força. O que você escreveu foi acolhido, lido e sentido. Agora respire fundo, coloque a mão no peito e se permita integrar tudo o que se abriu até aqui. No seu tempo, o seu Mapa de Cura dos 4 Elementos será construído a partir da sua verdade.',
    questions: [],
  },
]

export const ALL_QUESTION_IDS = VIVENCIAS.flatMap(v => v.questions.map(q => q.id))

/** Link do Protocolo exibido após a Vivência 5 (pode ser trocado quando o link definitivo chegar). */
export const PROTOCOLO_URL = 'https://jornada.reacendaluz.com.br/protocolo/'

/** Checkout do Mapa de Cura no Hotmart. */
export const HOTMART_CHECKOUT_URL = 'https://pay.hotmart.com/J108337633W?checkoutMode=10'

export const PRIVACIDADE_TEXTO =
  'Tudo que você escrever aqui é completamente privado. Suas respostas não são acessadas por ninguém além de você. O mapa gerado é seu e fica disponível apenas no seu acesso exclusivo.'
